import axios from "@/axiosInstance"; // ← la stessa instance usata altrove
import { createApp } from "vue";
import App from "./App.vue";
import router, { setAuth } from "./router";

/* ───── 1)  Plugins/componenti che NON necessitano dell’app già montata ───── */
import axiosPlugins from "@/axiosPlugin";
import ToastPlugin from "vue-toast-notification";
import Vue3Tour from "vue3-tour";
import SideBar from "./components/SideBar.vue";

import "@/assets/css/bell.css";
import "@/assets/css/data.css";
import "@/assets/css/modal.css";
import "leaflet/dist/leaflet.css";
import "vue-toast-notification/dist/theme-bootstrap.css";
import "vue3-tour/dist/vue3-tour.css";
import { bootstrapNotifications } from "./composables/useNotifications";

/* ─────────────────────────────────────────────────────────────────────────── */

async function bootstrap() {
	/* 2) Provi subito a capire “chi sono” */
	try {
		await axios.get("/auth/me", { withCredentials: true });
		setAuth(true);
		window.dispatchEvent(new Event("auth-ready")); // notifica i child
	} catch {
		setAuth(false);
	}

	/* 3)  Crei l’app SOLO dopo la chiamata */
	const app = createApp(App);

	/* — installazione plugin — */
	app.use(Vue3Tour)
		.use(ToastPlugin, {
			transition: "Vue-Toastification__bounce",
			maxToasts: 20,
			newestOnTop: true,
			closeOnClick: true,
			pauseOnFocusLoss: true,
			pauseOnHover: true,
			draggable: true,
			draggablePercent: 0.6,
			showCloseButtonOnHover: false,
			hideProgressBar: false,
			closeButton: "button",
			icon: true,
			rtl: false,
		})
		.use(axiosPlugins)
		.use(router);

	/* — global provide (API dei tour) — */
	app.provide("tours", app.config.globalProperties.$tours);

	/* — componenti globali — */
	app.component("SideBar", SideBar);

	/* 4) mount finale */
	app.mount("#app");

	// 🔔 bootstrap notifiche: fetch + socket
	bootstrapNotifications().catch(() => {});
}

bootstrap();
